import React from 'react';
import { CtaButton } from './CtaButton';
import { pricing } from '../data/pricing';
interface OfferCardProps {
  headingLevel?: 'h2' | 'h3';
}
export function OfferCard({
  headingLevel = 'h3'
}: OfferCardProps) {
  const Heading = headingLevel;
  return <div className="mx-auto w-full max-w-lg rounded-3xl bg-cream-50 p-5 text-center shadow-lift ring-1 ring-gold-500/30 sm:p-9" data-id="element-182" data-mp="rjax1svcrfbj">
      <Heading className="font-display text-xl font-900 uppercase leading-tight text-teal-900 sm:text-3xl" data-id="element-183" data-mp="1j84jw9g9fqu3">
        Mega Pack Acompañante
      </Heading>
      <p className="mt-1.5 font-display text-[0.7rem] font-700 uppercase tracking-[0.14em] text-gold-600 sm:mt-2 sm:text-sm sm:tracking-[0.16em]" data-id="element-184" data-mp="1f7kopbf8yxal">
        7 Tomos + 5 Bonos
      </p>

      <div className="mt-4 flex items-end justify-center gap-3 sm:mt-7" data-id="element-185" data-mp="15g6jqo4j15a2">
        <span className="text-base text-clay line-through sm:text-lg" data-id="element-186" data-mp="22wlpqdlr365u">
          {pricing.crossed}
        </span>
        <span className="font-display text-4xl font-900 leading-none text-teal-900 sm:text-5xl" data-id="element-187" data-mp="1y4lugygml1fl">
          {pricing.main}
        </span>
      </div>
      <p className="mt-2 text-[0.7rem] text-clay sm:text-xs" data-id="element-188" data-mp="8i5mh54py67z">
        Incluye los 5 bonos (valor simbólico {pricing.bonusesValue}) sin costo extra
      </p>

      <div className="mt-5 sm:mt-7" data-id="element-189" data-mp="3vs3vzwxkkjy0">
        <CtaButton label="Sí, quiero mi Mega Pack Acompañante" size="lg" data-id="element-190" data-mp="3vr2kjrcn5vfr" />
      </div>

      <p className="mt-3 text-[0.7rem] text-clay sm:mt-4 sm:text-xs" data-id="element-191" data-mp="3n00y7f8atkf">
        Pago seguro · Acceso inmediato · Garantía 7 días
      </p>

      <p className="mt-3 rounded-xl bg-teal-50 px-3 py-2 text-[0.7rem] leading-relaxed text-teal-700 sm:text-xs" data-id="element-192" data-mp="3qtit1pqxnm5v">
        Al finalizar la compra vas a poder sumar, de forma totalmente opcional, el
        complemento adicional por {pricing.upsell}.
      </p>
    </div>;
}